import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { EntityValue } from "@/model";
import entityValueRepository from "@/repository/entityValueRepository";
import { entityQueryKeys } from "@/query/entity";
import { entityValueQueryKeys } from "./keys";


interface DeleteEntityValueParams {
    ids?: string[];
    keyword?: string;
}

export const useDeleteEntityValue = (agentId: number, entityId: string) => {
    const queryClient = useQueryClient();

    return useMutation<EntityValue, AxiosError, DeleteEntityValueParams>({
        mutationKey: ['entity-value', 'delete', agentId, entityId],
        mutationFn: async (params: DeleteEntityValueParams) => {
            try {
                const { data } = await entityValueRepository.deleteMany(agentId, entityId, params.ids, params.keyword);
                return data.result;
            } catch (e) {
                throw e;
            }
        },
        retry: false,
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: entityQueryKeys.recent(agentId),
                exact: false
            });
            await queryClient.invalidateQueries({
                queryKey: entityValueQueryKeys.pageAll(agentId, entityId)
            });
        }
    });
};
